<h1 mat-dialog-title>{{ 'FORM.DLG_FORM_NOT_FOUND_TITLE' | translate }}</h1>
<mat-dialog-content>
  {{ data | translate }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial [mat-dialog-close]="true">{{ 'DIALOGS.OK' | translate }}</button>
</mat-dialog-actions>
